import type { ReactNode } from 'react';
import { cn } from '@/lib';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Gives a page inside the DashboardLayout its outer spacing and lets it fill the remaining height.
 * The layout itself has no spacing, so pages that must touch its edges (addon app iFrames) skip this.
 */
export function PageContainer({ children, className }: PageContainerProps) {
  return (
    // min-h-0 lets inner areas scroll instead of pushing the page past the viewport
    <div className={cn('m-4 flex min-h-0 flex-1 flex-col sm:m-6', className)}>{children}</div>
  );
}
